import { useEffect } from 'react';

type FloatingTimeTrackerKind = 'project' | 'lead';

const BODY_CLASS: Record<FloatingTimeTrackerKind, string> = {
  project: 'has-project-time-tracker',
  lead: 'has-lead-time-tracker',
};

/** Reserve bottom space in scroll areas while a floating time tracker is visible. */
export function useFloatingTimeTrackerBodyClass(kind: FloatingTimeTrackerKind, active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;

    const cls = BODY_CLASS[kind];
    document.body.classList.add(cls, 'has-floating-time-tracker');

    return () => {
      document.body.classList.remove(cls);
      if (
        !document.body.classList.contains('has-project-time-tracker')
        && !document.body.classList.contains('has-lead-time-tracker')
      ) {
        document.body.classList.remove('has-floating-time-tracker');
      }
    };
  }, [kind, active]);
}
